/** Format a ratio as a whole percentage without rounding a non-zero edge to
 * zero or a not-yet-complete edge to 100. */
export function formatPercentShare(share: number): string {
  if (share > 0 && share < 0.01) {
    return "<1%"
  }
  if (share > 0.99 && share < 1) {
    return ">99%"
  }
  return `${Math.round(share * 100)}%`
}
